import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CheckCircleIcon } from 'lucide-react';
const sessionBenefits = ['Afli ce drepturi îți garantează legea în situația ta', 'Înțelegi ce poți obține și ce nu poți obține prin instanță', 'Primești o strategie inițială clară pentru cazul tău', 'Pui toate întrebările fără grabă și fără judecată'];
export function FooterCTA() {
  return <section id="sesiune" className="bg-cream py-20 px-6" data-id="element-74">
      <div className="max-w-5xl mx-auto" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-76">
          <div className="text-gold font-label text-xs uppercase tracking-label mb-4" data-id="element-77">
            Sesiunea de Claritate Juridică
          </div>
          <h2 className="text-text-dark font-heading text-4xl md:text-5xl font-bold mb-6" data-id="element-78">
            Nu trebuie să știi totul. Trebuie doar să faci{' '}
            <span className="text-gold" data-id="element-79">primul pas</span>.
          </h2>
          <p className="text-text-dark-secondary font-body text-lg leading-relaxed max-w-3xl mx-auto" data-id="element-80">
            Rezervă o sesiune de claritate în care îți explic exact ce drepturi
            ai și ce poți obține în instanță. Suma se aplică integral la
            pachetul ales dacă decizi să continuăm împreună.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-lg p-8 md:p-10 border-l-[3px] border-emerald shadow-[0_4px_20px_rgba(12,35,64,0.08)] max-w-3xl mx-auto" data-id="element-81">
          <div className="grid sm:grid-cols-2 gap-4 mb-8" data-id="element-82">
            {sessionBenefits.map((benefit, i) => <div key={i} className="flex items-start gap-3" data-id="element-83">
                <CheckCircleIcon className="w-5 h-5 text-emerald flex-shrink-0 mt-0.5" strokeWidth={1.5} data-id="element-84" />
                <span className="font-body text-base text-text-dark-secondary leading-relaxed" data-id="element-85">
                  {benefit}
                </span>
              </div>)}
          </div>

          <div className="flex flex-col items-center border-t border-gray-100 pt-8" data-id="element-86">
            <div className="font-heading text-3xl font-bold text-text-dark mb-1" data-id="element-87">
              150 EUR <span className="text-gold" data-id="element-88">+ TVA</span>
            </div>
            <p className="font-body text-sm text-text-dark-secondary mb-6 text-center" data-id="element-89">
              Costul se aplică integral la pachetul ales dacă decizi să
              continuăm.
            </p>
            <Link to="/contact" className="inline-block bg-gold text-navy px-8 py-4 rounded font-label text-sm uppercase tracking-label hover:bg-gold/90 transition-colors" data-id="element-90">
              Rezervă Sesiunea de Claritate
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}